import React, { useEffect } from 'react';
import moment from 'moment';
import RangeDates from '../Basic/RangeDates';

function LayCan({
    lay, can, countIndex, changeFieldsMultiple, required = false, setHasErrors, 
}) {
    const minDate = moment().subtract(1, 'month').toDate();
    const handleChangeDate = (field, date) => {
        const toChange = [{
            index: countIndex,
            field,
            value: date,
        }];

        if (field === 'lay' && Date.parse(date) > Date.parse(can)) {
            toChange.push({
                index: countIndex,
                field: 'can',
                value: date,
            });
        }

        if (field === 'can' && Date.parse(lay) > Date.parse(date)) {
            toChange.push({
                index: countIndex,
                field: 'lay',
                value: date,
            });
        }

        changeFieldsMultiple(toChange);
    };

    useEffect(() => {
        if (required) {
            if (!lay || !can) {
                setHasErrors('layCan', true);
            } else {
                setHasErrors('layCan', false);
            }
        }
    }, [lay, can]);

    return (
        <RangeDates
            minDate={minDate}
            from={lay}
            until={can}
            handleChangeDate={handleChangeDate}
        />
    );
}

export default React.memo(LayCan);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/LayCan.jsx